export { ImagePipe, isSimpleImage, isSimpleVideo, getExtensionByUrl } from './image.pipe';
export { ImagePipeModule } from './image.pipe.module';
